import React from 'react';
import { useParams } from 'react-router';

import ActionButton from '@components/button/ActionButton';
import useSingleImmerseUKContactSync from './_hooks/useSingleImmerseUKContactSync';

const ImmerseUKContactSingleSync: React.FC = () => {
    const { id } = useParams<ParamType>();
    const { isSyncing, handleSync } = useSingleImmerseUKContactSync(id);

    return (
        <ActionButton
            color="blue"
            icon={`sync ${isSyncing ? 'fa-spin' : ''}`}
            isPosting={isSyncing}
            onClick={handleSync}
        >
            Sync
        </ActionButton>
    );
};

type ParamType = { id: string };

export default ImmerseUKContactSingleSync;
